import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import { RECEIVE } from '~/constants/errorCode';

import type {
  TypeApiResponse,
  TypeGetInboundAreaOperationTimesParams,
  TypeGetInboundAreaOperationTimesResponse,
} from '~/types/receive.types';

/**
 * [입고요청관리] 입고(예약)가능 시간대 목록 조회 API
 */
export const fetchInboundAreaOperationTimes = async (
  params: TypeGetInboundAreaOperationTimesParams
): Promise<TypeGetInboundAreaOperationTimesResponse> => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetInboundAreaOperationTimesResponse>>(
    '/api-inbound/v1/3pl/inbound-area/operation-times',
    { params }
  );
  return data.data;
};

const normalResponse: TypeApiResponse<TypeGetInboundAreaOperationTimesResponse> = {
  data: {
    operationTimes: [
      { operationTimeId: 1, operationTime: '09:00~12:00', availableSku: 50, availableUnit: 1500, disabled: false },
      { operationTimeId: 2, operationTime: '12:00~15:00', availableSku: 30, availableUnit: 900, disabled: false },
      { operationTimeId: 3, operationTime: '15:00~18:00', availableSku: 10, availableUnit: 200, disabled: false },
      { operationTimeId: 4, operationTime: '18:00~21:00', availableSku: 0, availableUnit: 0, disabled: true },
    ],
  },
};

const emptyResponse: TypeApiResponse<TypeGetInboundAreaOperationTimesResponse> = {
  data: {
    operationTimes: [],
  },
};

registerMockAPI<TypeApiResponse<TypeGetInboundAreaOperationTimesResponse>>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/inbound-area/operation-times',
  label: '입고/입고요청/운영시간',
  scenarios: [
    { name: '정상 응답 — 4시간대 (마지막 disabled)', response: normalResponse },
    { name: '정상 응답 — 빈 배열', response: emptyResponse },
    {
      name: '입고일시 없음 (9030)',
      response: {
        error: {
          code: RECEIVE.RECEIVE_DATE_TIME_NOT_EXIST,
          message: '선택한 일자에 운영 가능한 시간대가 없습니다.',
        },
      },
      status: 400,
    },
  ],
});
